import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
// import css from './css.module.less';
import React from 'react';
import { Form } from 'src/components/Antd';
import UsageLimitationComp, {
  EField,
} from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/UsageLimitation';
import { EDiscountType } from 'src/types/common/discount';
// import CollectionTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CollectionTable';
// import ProductTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductTable';
// import ProductTableUniqueSku from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductTableUniqueSku';
import { get } from 'lodash';
import { _type } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/CustomerEligible';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
export const maxPerCustomerCheckbox = [
  'userLimitation',
  'maxPerCustomerEnabled',
];
const Item = Form.Item;

////   const checkboxName = ['userLimitation', 'maxInTotalEnabled'];
//   const valueName = ['userLimitation', 'maxInTotal'];
const UsageLimitation = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { used, disableEdit } = props;
  //  const [test, setTest] = React.useState([]);
  return (
    <SectionWrapper
      //  containerClassName={css.sectionContainer}
      title={getI18n('salesChannelDirectDiscount.limitation.usageLimitation')}>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, 'discountType');
          const cV = get(c, 'discountType');
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const type = getFieldValue('discountType');
          let fields = [
            {
              field: EField.maxInTotal,
              checkboxName: ['userLimitation', 'maxInTotalEnabled'],
              valueName: ['userLimitation', 'maxInTotal'],
              description: null,
            },
            {
              field: EField.maxPerCustomer,
              checkboxName: ['userLimitation', 'maxPerCustomerEnabled'],
              valueName: ['userLimitation', 'maxPerCustomer'],
              disabledDependency: _type,
              description: null,
            },
          ];
          if (type === EDiscountType.Percentage) {
            fields = [
              {
                field: EField.maxInTotal,
                checkboxName: ['userLimitation', 'maxInTotalEnabled'],
                valueName: ['userLimitation', 'maxInTotal'],
                description: getI18n(
                  'salesChannelDirectDiscount.usage.percetageTip',
                ),
              },
              {
                field: EField.maxPerCustomer,
                checkboxName: ['userLimitation', 'maxPerCustomerEnabled'],
                valueName: ['userLimitation', 'maxPerCustomer'],
                disabledDependency: _type,
                description: getI18n(
                  'salesChannelDirectDiscount.usage.limitationTip',
                ),
              },
            ];
          }
          return (
            <UsageLimitationComp
              fields={fields}
              used={used}
              disableEdit={disableEdit}
            />
          );
        }}
      </Item>
      {/* <CollectionTable value={[]} />
      <ProductTable value={test} onChange={setTest} />
      <ProductTableUniqueSku value={[]} /> */}
    </SectionWrapper>
  );
};

export default UsageLimitation;
